/**
 * Rótulos de identidade do GRUPO FAMILIAR: benchmark e datas de frescor.
 *
 * Fonte ÚNICA. Nasceu porque a mesma leitura foi reescrita numa segunda tela e saiu errada nas duas
 * pontas (AZ-b449ba53, 01/09/2026): o benchmark do grupo é um OBJETO (`{ label, origem }`) e virou
 * `Benchmark do grupo: [object Object]` na tela; as datas chegam em `YYYY-MM-DD HH:mm` e foram
 * exibidas cruas, enquanto a tela irmã mostrava `DD/MM/YYYY HH:mm`.
 *
 * Quem renderiza identidade de grupo lê daqui — nunca do campo bruto.
 */

import { aawzDate } from '@utils/dates/aawz-date'

const DATE_OUTPUT_FORMAT = 'DD/MM/YYYY HH:mm'
const DATE_OUTPUT_FORMAT_CURTO_DIA = 'DD/MM/YYYY'
const DATE_OUTPUT_FORMAT_CURTO = 'DD/MM/YY HH:mm'
const DATE_INPUT_FORMATS = [
  'YYYY-MM-DD HH:mm',
  'YYYY-MM-DD',
  'DD/MM/YYYY HH:mm',
]

/**
 * @param {Object} grupo bloco `grupo` do payload de consolidação
 * @param {Object} [opcoes]
 * @param {Boolean} [opcoes.comOrigem] prefixa `Padrão do escritório (...)` quando o benchmark não
 *   foi escolhido no grupo — só o cabeçalho identifica a origem; tabela e legenda querem o rótulo cru
 * @returns {String} rótulo do benchmark, ou string vazia
 */
export const resolveGroupBenchmarkLabel = (
  grupo,
  { comOrigem = false } = {}
) => {
  const benchmark = grupo && grupo.benchmark
  if (!benchmark || typeof benchmark !== 'object') return ''
  if (comOrigem && benchmark.origem === 'default_escritorio') {
    return `Padrão do escritório (${benchmark.label || 'CDI'})`
  }
  return benchmark.label || ''
}

/**
 * @param {Object} portfolioStatistics bloco `portfolio_statistics` da consolidação do grupo
 * @returns {String} `Desde DD/MM/YYYY (entrada do membro mais antigo)`, ou string vazia
 */
export const resolveGroupStartLabel = (portfolioStatistics) => {
  const inicio = portfolioStatistics && portfolioStatistics.data_inicio
  if (!inicio) return ''
  const data = aawzDate(inicio, 'YYYY-MM-DD')
  if (!data.isValid()) return ''
  return `Desde ${data.format(
    DATE_OUTPUT_FORMAT_CURTO_DIA
  )} (entrada do membro mais antigo)`
}

/**
 * @param {String} valor data em qualquer um dos formatos que a rota entrega
 * @param {Object} [opcoes]
 * @param {Boolean} [opcoes.curto] usa `DD/MM/YY HH:mm`, o formato dos chips de Carteiras
 * @returns {String} data formatada, ou string vazia
 */
export const formatGroupDate = (valor, { curto = false } = {}) => {
  if (!valor) return ''
  const saida = curto ? DATE_OUTPUT_FORMAT_CURTO : DATE_OUTPUT_FORMAT
  for (const formato of DATE_INPUT_FORMATS) {
    const data = aawzDate(valor, formato)
    if (data.isValid()) return data.format(saida)
  }
  return ''
}

/**
 * @param {String} valor data crua da rota
 * @returns {String} a MESMA data no formato que `statusDesatualizado` espera (`DD/MM/YYYY HH:mm`)
 */
export const toStatusInput = (valor) => formatGroupDate(valor)
